// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__oDqRH","box":"styles_box__eMook","icon":"styles_icon__QYFPb"};